import { createSlice } from '@reduxjs/toolkit';

export const showContactWidget = createSlice({
    name: 'showContactWidget',
    initialState: true,
    reducers: {
        setHideContactWidget: () => false
    }
});

// actions export
export const { setHideContactWidget } = showContactWidget.actions;
// state export
export const selectShowContactWidget = (state) => state.showContactWidget;
// exporting the reducer here, as we need to add this to the store
export default showContactWidget.reducer;